var _path, _rect, _rect2, _rect3, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductGroupInfo3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 99,
    viewBox: "0 0 105 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9087 82.5495V47.8572H70.7548V82.5495H32.9087ZM45.5241 54.1649H39.2164V76.2418H64.4472V54.1649H58.1395V66.7803L51.8318 60.4726L45.5241 66.7803V54.1649Z",
    fill: "#D23778"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.832,
    y: 16,
    width: 4,
    height: 14,
    rx: 2,
    fill: "#FF64A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9824,
    y: 27.5413,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(31 78.9824 27.5413)",
    fill: "#FF64A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 30.4797,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(-42 19 30.4797)",
    fill: "#FF64A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.332,
    cy: 78.3572,
    r: 13.5,
    fill: "#FF64A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4859 69.8572C70.1205 69.8572 68.1782 71.7995 68.1782 74.1649V76.011H66.332V85.8572H78.6397V76.011H76.7936V74.1649C76.7936 71.7995 74.8513 69.8572 72.4859 69.8572ZM72.4859 71.0879C74.1806 71.0879 75.5628 72.4702 75.5628 74.1649V76.011H69.409V74.1649C69.409 72.4702 70.7912 71.0879 72.4859 71.0879ZM77.409 84.6264V77.2418H67.5628V84.6264H77.409Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductGroupInfo3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-group-info-3.0e6a7432298d0096f6d90d2bf006d6ae.svg";